const Field = require('../field')
const Comparator = require('../comparator')

class Condition {
  constructor(condition) {
    this.id = condition.id || condition._id
    this._id = this.id
    this.field = new Field(condition.field)
    this.comparator = new Comparator(condition.comparator)
    this.value = condition.value
  }

  valid(room) {
    if (this.field.containsId(room)) {
      const id = this.field.getId(room)
      if (id instanceof Array) {
        if (id.length !== this.value.length) {
          return false
        }
        const compares = id.map((i, index) => {
          if (i) {
            return this.comparator.compare(i, this.value[index].id)
          } else {
            const value = this.field.getFieldValue(room)
            return this.comparator.compare(value[index], this.value[index])
          }
        })
        return !compares.includes(false)
      } else {
        return this.comparator.compare(id, this.value.id)
      }
    } else {
      const value = this.field.getFieldValue(room)
      if (value instanceof Array) {
        if (value.length !== this.value.length) {
          return false
        }
        const compares = value.map((v, index) => {
          if (v.id) {
            return this.comparator.compare(v.id, this.value.id)
          } else {
            return this.comparator.compare(v, this.value[index])
          }
        })
        return !compares.includes(false)
      } else {
        return this.comparator.compare(value, this.value)
      }
    }
  }
}

module.exports = Condition
